import { Box, Avatar, Card } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  width: "100%",
});

export const ContentWrapper = styled(Box)({
  width: "100%",
});

export const HeaderBox = styled(Box)(({ theme }) => ({
  background: "linear-gradient(135deg, #1c75ff, #4b9dff)",
  color: "white",
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  textAlign: "center",
  borderRadius: theme.spacing(3),
  marginBottom: theme.spacing(4),
  boxShadow: "0 8px 32px rgba(28, 117, 255, 0.2)",
}));

export const StepperContainer = styled(Box)(({ theme }) => ({
  maxWidth: 900,
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: theme.spacing(4),
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(3),
  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
}));

export const BenefitCard = styled(Card)(({ theme }) => ({
  textAlign: "center",
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  height: "100%",
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
}));

export const BenefitAvatar = styled(Avatar)(({ bgcolor, color, theme }) => ({
  backgroundColor: bgcolor,
  color: color,
  width: 64,
  height: 64,
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: theme.spacing(2),
}));
